import api from 'Application/api/api';

const getPPEs = (id, cancelToken = null) =>
    api.get(`project-manager/projects/introductions/ppes`, {
        cancelToken,
    });

export default getPPEs;
